import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isValidDate(date: Date | string): boolean {
  const inputAsString = date.toString();
  if (inputAsString.length !== 10) {
    return false;
  }

  const dateAsDate = new Date(date);
  if (isNaN(dateAsDate.getTime())) {
    return false;
  }

  return true;
}

export function isValidDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value && !isValidDate(control.value) ? { isValidDate: true } : null;
  };
}

export function isInPast(date: Date | string): boolean {
  const now = new Date();
  return new Date(date) < now;
}

export function isInPastValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value && !isInPast(control.value) && !isInPast(control.value) ? { dateInPast: true } : null;
  };
}

export function getDateFormatForLang(lang: string): string {
  switch (lang) {
    case 'nl-NL':
      return 'dd-MM-yyyy';
    case 'de-DE':
      return 'dd.MM.yyyy';
    case 'fr-FR':
      return 'dd/MM/yyyy';
    case 'fi-FI':
      return 'dd.MM.yyyy';
    case 'en-US':
      return 'MM/dd/yyyy';
    case 'en-GB':
      return 'dd/MM/yyyy';
    default:
      return 'MM/dd/yyyy';
  }
}

export function getDateYearsFromNow(years: number): {
  year: number;
  month: number;
  day: number;
} {
  const today = new Date();
  return {
    year: today.getFullYear() + years,
    month: today.getMonth() + 1,
    day: today.getDate(),
  };
}
